export const SUBMIT_SUPPLIER = "SUBMIT_SUPPLIER";
export const SUBMIT_SUPPLIER_SUCCESS = "SUBMIT_SUPPLIER_SUCCESS";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS";
export const LOAD_SUPPLIER = "LOAD_SUPPLIER";
export const LOAD_SUPPLIER_SUCCESS = "LOAD_SUPPLIER_SUCCESS";
export const SUPPLIER_API_ERROR = "SUPPLIER_API_ERROR";